import { render } from "./SendSms.vue?vue&type=template&id=2ad9a3ac"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"
script.render = render

export default script